export default {"src":"/_next/static/media/dataCenterLogo.5445359e.svg","height":345,"width":600,"blurWidth":0,"blurHeight":0};